import { InjectionToken } from "@angular/core";

// Create the injection token for the custom settings
export const LOGIN_URL = new InjectionToken('cimbLoginUrl');
